import { render, staticRenderFns } from "./FlourInput.vue?vue&type=template&id=32085991&scoped=true&"
import script from "./FlourInput.vue?vue&type=script&lang=ts&"
export * from "./FlourInput.vue?vue&type=script&lang=ts&"
import style0 from "./FlourInput.vue?vue&type=style&index=0&id=32085991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32085991",
  null
  
)

export default component.exports